(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }

  // Read vars from attributes
  var adv_ratio = productRecommendationsSection.dataset.adv_ratio;
  var prod_thumb_img_ratio = productRecommendationsSection.dataset.prod_thumb_img_ratio;

  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      // set correct image shape
      if(adv_ratio == 'true'){
        var $firstImage = $('.rimage-wrapper:first', productRecommendationsSection);
        var ar = $firstImage.width() / $firstImage.outerHeight();
        $('.rimage-wrapper:not(:first)', productRecommendationsSection).each(function(){
          var thisAr = $(this).width() / $(this).outerHeight();
          if(
            (prod_thumb_img_ratio == 'tallest' && thisAr < ar) ||
            (prod_thumb_img_ratio == 'shortest' && thisAr > ar)
          ) {
            ar = thisAr;
          }
        });
        if(prod_thumb_img_ratio == 'tallest' || prod_thumb_img_ratio == 'shortest') {
          $('.rimage-wrapper', productRecommendationsSection).css('padding-top', ((1.0 / ar) * 100.0).toFixed(2) + '%');
        }
      }

      // init masonry layout
      $(document).trigger('loadmasonry');
    }
  };
  request.send();
};

// Reload the section as you edit theme settings
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});

// When the section is unloaded, detach the Masonry plugin to tidy up
document.addEventListener("shopify:section:unload", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    $('.blocklayout', event.target).masonry('destroy');
  }
});

// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();
})();
